import { render, staticRenderFns } from "./paper_stat.vue?vue&type=template&id=5c9f0a94"
import script from "./paper_stat.vue?vue&type=script&lang=js"
export * from "./paper_stat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports